import { ChannelType, Template } from '../../../../types/communication';
import { newEnvelopeDraft, newTemplateDraft } from '../composition/studio/studioDraft';

export type TemplateKind = 'EMAIL_BODY' | 'EMAIL_ENVELOPE' | 'INTERNAL_MESSAGE' | 'EXTERNAL_MESSAGE';

interface TemplateKindInfo {
    label: string;
    format: string;
    storage: string;
    channel: ChannelType;
    description: string;
}

export const TEMPLATE_KINDS: Record<TemplateKind, TemplateKindInfo> = {
    EMAIL_BODY: {
        label: 'Corpo de e-mail',
        format: 'HTML',
        storage: 'SES',
        channel: 'EMAIL',
        description: 'O conteúdo do e-mail. Fica guardado no SES.',
    },
    EMAIL_ENVELOPE: {
        label: 'Envio de e-mail',
        format: 'JSON',
        storage: 'Aplicação',
        channel: 'EMAIL',
        description: 'Assunto, remetente, destinatários e arquivos do e-mail.',
    },
    INTERNAL_MESSAGE: {
        label: 'Mensagem interna',
        format: 'Markdown',
        storage: 'Aplicação',
        channel: 'INTERNAL_MESSAGE',
        description: 'Texto do alerta publicado no chat dos times (Slack).',
    },
    EXTERNAL_MESSAGE: {
        label: 'WhatsApp',
        format: '—',
        storage: 'Blip',
        channel: 'EXTERNAL_MESSAGE',
        description: 'Modelo aprovado no WhatsApp, com os espaços ligados a variáveis.',
    },
};

export const TEMPLATE_KIND_ORDER: TemplateKind[] = ['EMAIL_BODY', 'EMAIL_ENVELOPE', 'INTERNAL_MESSAGE', 'EXTERNAL_MESSAGE'];

// Tipos que o usuário pode criar como modelo livre: o "Envio de e-mail" (ENVELOPE) só existe
// dentro de uma composição, e o WhatsApp é criado no Blip — então ficam fora do "Novo modelo".
export const CREATABLE_TEMPLATE_KINDS: TemplateKind[] = ['EMAIL_BODY', 'INTERNAL_MESSAGE'];

export const templateKind = (template: Template): TemplateKind => {
    if (template.channel === 'EMAIL') return template.role === 'ENVELOPE' ? 'EMAIL_ENVELOPE' : 'EMAIL_BODY';
    return template.channel;
};

export const newTemplateOfKind = (kind: TemplateKind): Template => {
    if (kind === 'EMAIL_ENVELOPE') return newEnvelopeDraft('NOVO_ENVIO');
    return newTemplateDraft(TEMPLATE_KINDS[kind].channel, 'NOVO_MODELO');
};
